import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { Icons } from '@/assets/icons/icons';
import { SidebarListItemFrame } from '@/components/blocks/Layout/Sidebar/SidebarListItemFrame';
import { SidebarSectionRow } from '@/components/blocks/Layout/Sidebar/SidebarSectionRow';
import { isNewTabClick, useTabs } from '@/features/tabs';
import { useDrawerNavigation } from '@/providers/DrawerNavigationProvider';
import { Panel } from '@/stores/ui.store';

import { type GhostChat } from './ghost-chats';
import {
  ghostChatsState,
  type GhostChatSidebarItem,
} from './ghost-chats.state';

export function GhostChatVListItem({
  item,
  isSectionBoundary,
  hasFollowingSection = false,
}: {
  item: GhostChatSidebarItem;
  isSectionBoundary: boolean;
  hasFollowingSection?: boolean;
}) {
  const navigate = useNavigate();
  const { openTab } = useTabs();
  const { setIsOpen } = useDrawerNavigation();

  useEffect(() => ghostChatsState.observeShown(item.ghost), [item.ghost]);

  const selectGhostChat = (ghost: GhostChat, e?: React.MouseEvent) => {
    setIsOpen(false);
    ghostChatsState.markClicked(ghost);
    const search = { auto_prompt: ghost.prompt };
    if (e && isNewTabClick(e)) {
      openTab({ path: '/chats', search });
    } else {
      navigate({ to: '/chats', search });
    }
  };

  return (
    <SidebarListItemFrame
      section={item.section}
      isSectionBoundary={isSectionBoundary}
      hasFollowingSection={hasFollowingSection}
      data-testid={`ghost-chat-${item.ghost.id}`}
    >
      <SidebarSectionRow
        item={item.ghost}
        title={item.ghost.title}
        onSelect={selectGhostChat}
        panel={Panel.Chats}
        showLeading={false}
        muted
        rightSide={
          <Icons.sparkles className="size-3 shrink-0 text-foreground-muted" />
        }
      />
    </SidebarListItemFrame>
  );
}
